module.exports = __webpack_public_path__ + "img/term.8c39bfcf.svg";